import { render } from "./Get.vue?vue&type=template&id=f1b38202&ts=true"
import script from "./Get.vue?vue&type=script&lang=ts"
export * from "./Get.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/firebridge_dev/fblogin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__